<template>
  <div class="page">
    <div v-if="loginInfo" class="login-out" @click="loginOut">退出登录</div>
    <div class="activity-title" v-html="activity?.activityTitle||'大连天成润滑油“开门红”大抽奖'"></div>
    <div class="table">
      <div class="cell" v-for="(item,idx) in prizeList" :key="idx" :class="{active:active===idx}"
           :style="{'background-image': `url(${item.url})`}">
        <div class="prize">{{ item?.name }}</div>
      </div>
    </div>
    <div class="zhizhen" @click="choujiang">立即抽奖</div>
    <div class="tips">您还有 <span class="num">{{ num }}</span> 次抽奖机会</div>
    <div class="title flex-center"><span>活动规则</span></div>
    <div class="box pading-30" v-html="activity?.activityExplain||''"></div>

    <div class="title flex-center"><span>中将记录</span></div>
    <div class="box min-h-200">
      <div class="list" v-for="(records, index) in myWinList" :key="index">
        <div style="background-color: rgba(0, 0, 0, .2);color:#ffc107;">第{{ index + 1 }}轮</div>
        <div v-for="(item,idx) in records" :key="idx">
          {{ item.name }}
        </div>
      </div>
      <div class="no-data" v-if="myWinList.length === 0">暂无记录</div>
    </div>

    <!-- 登录注册 -->
    <div class="login-box" v-if="activityId && !loginInfo">
      <div class="login">
        <div class="login-title">{{ isRegister ? '注册' : '登录' }}</div>
        <div class="input-s">
          <input v-if="isRegister" type="text" v-model="user.customerName" placeholder="请输入您的姓名" />
          <input type="text" v-model="user.customerPhone" placeholder="请输入您手机号" />
          <input type="password" v-model="user.customerPassword" placeholder="请输入密码" />
          <input v-if="isRegister" type="password" v-model="user.okpassword" placeholder="请确认密码" />
          <button @click="register">{{ isRegister ? '注册' : '登录' }}</button>
          <p @click="isRegister = !isRegister">{{ isRegister ? '我要登录' : '我要注册' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from './api'
import {MessageBox, Toast} from 'mint-ui';
// const ROTATE_INIT = 1460 // 旋转基础角度

export default {
  name: 'App',
  data() {
    return {
      activity: null,
      prizeList: [], // 奖项列表
      // winList: [], // 获奖列表
      myWinList: [], // 我的抽奖列表
      totalMoney: '', // 销售总金额
      // saleList: [], // 销售列表
      loading: false,
      firstComin: true,
      num: 0, // 抽奖次数
      rotate: 0, // 旋转角度
      transition: 0, // 旋转时间
      activityId: null, // 活动id
      recordId: null, // 记录id
      isRegister: false,  // 是否注册
      user: {  // 登录、注册信息
        customerName: '',
        customerPhone: '',
        customerPassword: '',
        okpassword: '',
      },
      loginInfo: null,  // 登录信息
      orderPrice: 3000, //
      active: -1,
      task: null
    }
  },
  mounted() {
    const query = this.getUrlQuery()
    if (query.activityId) {
      this.activityId = query.activityId
      localStorage.setItem('activityId', query.activityId)
    } else {
      Toast('参数错误')
      return false
    }

    if (query.recordId) {
      this.recordId = query.recordId
    }

    const loginInfo = localStorage.getItem('loginInfo')
    if (loginInfo) {
      this.loginInfo = JSON.parse(loginInfo)
      if (this.recordId) {
        this.bindRecord()
      }
    } else {
      Toast('请先登录')
      return false
    }

    this.getActivityAll()
    // setInterval(() => {
    //   this.getActivityAll()
    // }, 10000)
  },
  methods: {

    // 获取抽奖数据列表
    getActivityAll() {
      return Api.getActivityAll(this.activityId, this.loginInfo.customerId).then(async res => {
        if (res.code !== 200) {
          MessageBox.alert(res.msg || '未知错误')
          return false
        }

        const {
          activity,
          times,
          records,
          orderPrice
        } = res.data
        this.activity = activity;
        this.orderPrice = orderPrice
        // console.log(activity, times, records);
        if (this.firstComin && this.loginInfo) {
          // MessageBox.alert(`第 ${activity.idx} 轮抽奖`)
          this.firstComin = false
        }
        await this.setPrizeList(activity)
        console.log(this.prizeList)
        // this.setWinList(activity, records)
        // 获取我的抽奖记录 和抽奖册数
        if (this.loginInfo) {
          this.setMyWinList(times, records)
          this.setMyDrawNum(records)
        }
        // this.setSaleList(records)

        return true
      })
    },

    // 设置奖项
    setPrizeList(activity) {
      return Api.listByIds(activity.prizeArr.map(item => item.fileList).join(','))
          .then(rs => {
            const files = rs.data
            activity.prizeArr.forEach(item => {
              const file = files.find(f => f.ossId === item.fileList);
              if (file) {
                item.url = file.url
              }
            })
            this.prizeList = activity.prizeArr
          })
    },
    // 中奖列表展示
    setWinList(activity, records) {
      let tmpList = records.filter(item => item.status === 3).sort((a, b) => a.result - b.result)
      tmpList = tmpList.length > 10 ? tmpList.slice(0, 10) : tmpList
      this.winList = tmpList.map(item => {
        const phone = item.customerPhone
        return {
          v1: this.safePhone(phone),
          v2: activity[`title${item.result}`]
        }
      })
    },

    // 获取我的抽奖记录
    setMyWinList(times, records) {
      let tmpList = records.filter(item => item.status === 3).sort((a, b) => a.result - b.result)
      const tmpList2 = []
      for (const t of times) {
        const line = []
        for (const item of tmpList) {
          if (item.timesId === t.timesId) {
            line.push(this.prizeList[parseInt(item.result)])
          }
        }
        tmpList2.push(line)
      }
      this.myWinList = tmpList2
    },

    // 获取我的抽奖次数
    setMyDrawNum(records) {
      this.num = records.filter(item => {
        return item.status === 2 && item.customerPhone === this.loginInfo.customerPhone
      }).length
    },

    // 计算销售额
    setSaleList(records) {
      records = records.filter(item => item.status > 1)
      // 总销售额
      this.totalMoney = (records.length * this.orderPrice).toLocaleString()
      const tmpMap = new Map()
      records.forEach(record => {
        const customer = tmpMap.get(record.customerPhone)
        if (customer) {
          tmpMap.set(record.customerPhone, customer + 1)
        } else {
          tmpMap.set(record.customerPhone, 1)
        }
      })
      let tmpList = []
      tmpMap.forEach((v, k) => {
        tmpList.push({
          v1: this.safePhone(k),
          v2: (v * this.orderPrice).toLocaleString()
        })
      })
      tmpList = tmpList.sort((a, b) => b.v2 - a.v2)
      this.saleList = tmpList
    },

    // 手机号格式化
    safePhone(phone) {
      if (!phone) {
        return ''
      }
      return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4)
    },

    getUrlQuery() {
      const url = window.location.href.split('?')[1]
      if (url) {
        const querys = url.split('&')
        let query = {}
        querys.forEach(item => {
          const pram = item.split('=')
          query[pram[0]] = pram[1]
        })
        return query
      }
      return false
    },

    // 去登陆注册
    register() {

      if (this.isRegister) {

        if (!this.user.customerName || !this.user.customerPhone || !this.user.customerPassword || !this.user.okpassword) {
          Toast('请正确输入正确的信息')
          return false
        }

        if (this.user.customerPassword !== this.user.okpassword) {
          Toast('两次输入密码不一致')
          return false
        }

        Api.register(this.user).then(res => {
          console.log('register', res);
          if (res.code !== 200) {
            MessageBox.alert(res.msg || '未知错误')
            return false
          }

          this.loginInfo = res.data
          localStorage.setItem('loginInfo', JSON.stringify(res.data))
          if (this.recordId) {
            this.bindRecord()
          } else {
            this.getActivityAll()
          }
        })

      } else {

        if (!this.user.customerPhone || !this.user.customerPassword) {
          Toast('请正确输入正确的信息')
          return false
        }

        Api.login({
          customerPhone: this.user.customerPhone,
          customerPassword: this.user.customerPassword
        }).then(res => {
          console.log('login', res);
          if (res.code !== 200) {
            MessageBox.alert(res.msg || '未知错误')
            return false
          }

          this.loginInfo = res.data
          localStorage.setItem('loginInfo', JSON.stringify(res.data))
          if (this.recordId) {
            this.bindRecord()
          } else {
            this.getActivityAll()
          }
        })

      }
    },

    // 退出登录
    loginOut() {
      localStorage.removeItem('loginInfo')
      this.loginInfo = null
    },

    // 绑定销售记录
    bindRecord() {
      Api.bindRecordId(this.recordId, this.loginInfo.customerId).then(res => {
        if (res.code !== 200) {
          MessageBox.alert(res.msg || '未知错误')
          return false
        }
        this.recordId = null
        this.getActivityAll()
      })
    },

    // 去抽奖
    async choujiang() {
      // 没有活动id
      if (!this.activityId || !this.loginInfo) {
        Toast('参数错误')
        return false
      }

      if (this.loading) return
      this.loading = true

      this.active = -1

      // 抽奖接口 然后计算旋转基础角度 + 中奖角度
      Api.userDraw(this.activityId, this.loginInfo.customerId)
          .then(res => {
            if (res.code !== 200) {
              MessageBox.alert(res.msg || '未知错误')
              this.loading = false
              return false
            }

            const prizeNum = ~~res.data.result // 几等奖
            let times = prizeNum
            if (times < 5) {
              times = this.prizeList.length + prizeNum
            }
            this.task && clearInterval(this.task)
            this.task = setInterval(() => {
              if (times-- < 1) {
                this.task && clearInterval(this.task)
                MessageBox({
                  title: `恭喜中奖啦！`,
                  message: this.prizeList[prizeNum] ? `奖品：${this.prizeList[prizeNum].name}` : '',
                  showCancelButton: false
                });
                this.loading = false
                this.getActivityAll()
              }
              let idx = this.active + 1;
              if (idx >= this.prizeList.length) {
                idx = 0
              }
              this.active = idx;
            }, 200)
          })
    },
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.activity-title {
  margin: 20px auto;
  padding: 0 20px;
  text-align: center;
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  text-shadow: 4px 4px 2px #f62c2c;
}

#app {
  margin: 0;
  padding: 0;
}

.page {
  color: #000;
  padding: 30px 0;
  width: 100%;
  min-height: 100vh;
  background: url("@/assets/bg.png") center no-repeat;
  background-size: cover;
  overflow-y: auto;
}

.login-out {
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  padding: 10px;
}

.company {
  margin: 0 auto;
  width: 240px;
  height: 41px;
  background-image: url('@/assets/name.png');
  background-size: 100% 100%;
}

.des {
  margin: 0 auto;
  width: 180px;
  height: 30px;
  background-image: url('@/assets/des.png');
  background-size: 100% 100%;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.table {
  margin: 20px;
  display: grid;
  gap: 10px;
  background-color: rgba(0, 0, 0, .2);
  background-image: linear-gradient(#4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%),
  linear-gradient(90deg, #4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%),
  linear-gradient(#4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%),
  linear-gradient(90deg, #4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%);
  background-repeat: no-repeat;
  background-origin: padding-box;
  background-position: top left, top left, bottom right, bottom right;
  background-size: 10px 100%, 100% 10px;
  padding: 10px;
  grid-template-columns: repeat(4, 1fr);
}

.table .cell {
  width: 100%;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  display: flex;
  justify-content: center;
  align-items: end;
  text-align: center;
  border-radius: 10px;
  box-shadow: 3px 3px 4px #85000b,
  inset 3px 3px 4px #fff;
  //padding: 8px;
  background-color: #f8f0cd;
  transition: .3s all;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 12px;
}

.table .cell .prize {
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #ff9800;
  width: 100%;
}

.table .cell.active {
  border: 4px solid #e70312;
  transform: scale(1.3);
  box-shadow: none;
}

.zhizhen {
  background-size: 100% 100%;
  margin: 0 auto;
  font-size: 1.5rem;
  text-align: center;
  font-weight: 600;
  color: #fff;
  background-color: #ff9800;
  padding: 20px;
  width: fit-content;
  border-radius: 8px;
  box-shadow: 3px 3px 4px #85000b,
  inset 3px 3px 4px #fff;
}

.zhizhen:active {
  box-shadow: 3px 3px 4px #fff,
  inset 3px 3px 4px #85000b;
}

.item {
  position: relative;
  width: 300px;
  height: 300px;
}

.spilt {
  color: #000;
  transform-origin: 50% 100%;
}

.spilt .info {
  position: absolute;
  top: 0;
  padding-top: 15px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.item .spilt {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 0;
  left: 64px;
  padding-top: 20px;
  width: 172px;
  height: 150px;
  /* background-color: #fff; */
}

.item .spilt::before {
  position: absolute;
  top: 0;
  display: block;
  content: '';
  width: 0;
  height: 0;
  border-width: 150px 84px 0 84px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}

.item-line {
  width: 4px;
  height: 300px;
  background: linear-gradient(#ff9800, #ff9800 150px, transparent 150px, transparent);
  z-index: 999;
  position: absolute;
  top: 0;
  left: 148px;
}

.tips {
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
  color: #fff;
  font-size: 16px;
}

.num {
  font-size: 24px;
  color: #ffc107;
  text-shadow: 2px 2px 2px #f62c2c;
}

.title {
  position: relative;
  margin: 0 auto 10px;
  width: 200px;
  height: 30px;
  transform: skew(-30deg);
  background: linear-gradient(to right,
  #ffc107, #ffc107 8px, transparent 8px, transparent 11px,
  #ffc107 11px, #ffc107 14px, transparent 14px, transparent 17px,
  #ffc107 17px, #ffc107 20px, transparent 20px, transparent 23px,
  #ffc107 23px, #ffc107 calc(100% - 21px),
  transparent calc(100% - 21px), transparent calc(100% - 18px), #ffc107 calc(100% - 18px), #ffc107 calc(100% - 11px),
  transparent calc(100% - 11px), transparent calc(100% - 8px), #ffc107 calc(100% - 8px), #ffc107 calc(100% - 5px),
  transparent calc(100% - 5px), transparent calc(100% - 2px), #ffc107 calc(100% - 2px), #ffc107 100%);
}

.title span {
  transform: skew(30deg);
}

.box {
  color: #fff;
  margin: 0 auto 20px;
  padding: 10px;
  width: 350px;
  background-color: rgba(0, 0, 0, .2);
  background-image: linear-gradient(#4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%),
  linear-gradient(90deg, #4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%),
  linear-gradient(#4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%),
  linear-gradient(90deg, #4cc7f3 2px, transparent 2px, transparent calc(100% - 2px), #4cc7f3 calc(100% - 2px), #4cc7f3 100%);
  background-repeat: no-repeat;
  background-origin: padding-box;
  background-position: top left, top left, bottom right, bottom right;
  background-size: 10px 100%, 100% 10px;
}

.pading-30 {
  padding: 30px;
}

.min-h-200 {
  min-height: 200px;
}

.list {
  margin-bottom: 5px;

  div {
    width: 100%;
    flex: 1;
    text-align: center;
    margin-right: 2px;
    background-color: rgba(239, 210, 210, .2);
    color: white;
  }

  div + div {
    margin-top: 6px;
  }
}

.no-data {
  padding: 80px 0;
  width: 100%;
  text-align: center;
  color: #ccc;
}

.login-box {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  font-size: 16px;
  background-color: rgba(0, 0, 0, .4);
}

.login-box .login {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 300px;
  background-color: #fff;
  border-radius: 12px;
}

.login-title {
  padding: 10px 0;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.input-s {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.input-s input,
.input-s button {
  margin-bottom: 20px;
  width: 260px;
  height: 40px;
  font-size: 16px;
  border: 1px solid #e9e9e9;
  outline-color: #ae0029;
}

.input-s input {
  padding: 0 10px;
}

.input-s button {
  color: #fff;
  background-color: #ae0029;
}

.input-s p {
  font-size: 14px;
  text-decoration: underline;
}
</style>
